<template>
    <div class="filling-goods-div">
        <div style="padding-top: 5px; font-size: 16px">半成品出库</div>
        <div class="filling-goods-head">
            <div class="filling-goods-head-div">
                <div class="head-input-div" style="margin-bottom: 5px;">
                    <div style="width: 20%; text-align: left">货号:</div>
                    <input class="out-input" readonly="readonly" v-model="goods_number" />
                </div>
                <div class="head-input-div" style="margin-bottom: 5px;">
                    <div style="width: 20%; text-align: left">款式:</div>
                    <input class="out-input" readonly="readonly" v-model="ksType" />
                </div>
                <div class="head-input-div" style="margin-bottom: 5px;">
                    <div style="width: 20%; text-align: left">数量:</div>
                    <input class="out-input" readonly="readonly" v-model="count" />
                </div>
            </div>
            <div class="filling-goods-head-div">
                <div class="head-input-div" style="margin-bottom: 5px;">
                    <div style="width: 30%; text-align: left">高度(m):</div>
                    <input class="out-input" readonly="readonly" :value="height_num" />
                </div>
                <div class="head-input-div" style="margin-bottom: 5px;">
                    <div style="width: 30%; text-align: left">宽度(m):</div>
                    <input class="out-input" readonly="readonly" name="normsware" :value="width_num" />
                </div>
                <div class="head-input-div" style="margin-bottom: 5px;">
                    <div style="width: 30%; text-align: left">货位:</div>
                    <input class="out-input" readonly="readonly" v-model="goods" />
                </div>
            </div>
        </div>
        <div style="display: flex;  padding:0px 10px 10px 10px;align-items: center;justify-content: center;">
            <div style="width: 20%; text-align: left">备注:</div>
            <input style="width: 80%;height: 25px; line-height: 25px;" readonly="readonly" :value="reelInfo" />
        </div>

        <span style="color: red" v-if="hostcs">测试服</span>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;" v-if="outNumber === '未出库'">
            <van-button type="info" size="small" style="display: flex" :text="ray" @click="holdRay()"></van-button>
            <div>
                <input id="reel-input" class="get-input" @keyup.enter="goGck()" ref="getIDInpot" v-model="reeldata"
                    v-on:blur="hideMessage('reeldata')" readonly autocomplete="off" placeholder="扫描卷号" />
            </div>
        </div>
        <div style="display: flex; justify-content: flex-end; align-items: center" v-if="outNumber === '未出库'">
            <div>
                <input id="reel-input" class="get-input" @keyup.enter="goSX()" ref="getGCKInpot" v-model="gckdata"
                    v-on:blur="hideMessage('gckdata')" readonly autocomplete="off" placeholder="扫描明细码" />
            </div>
        </div>
        <div style="padding: 10%;" v-if="success">
            <div class="info-data">
                <div style="width: 40%; text-align: left; font-size: 18px;">出库数量:</div>
                <input style="width: 40%; font-size: 18px; height: 30px; line-height: 30px; padding: 0px 10px;"
                    v-model="count_up" type="number" />
            </div>
            <div style="padding-top: 20px;" v-if="success">
                <van-button type="info" round class="bottom-button-x" @click="go_save()">保存</van-button>
            </div>
        </div>
        <van-popup v-model="show_print" style="width: 200px;">
            <div style="padding:10px;" class="print-only" id="popupPrint">
                <div>
                    <div class="list-data">
                        <div class="list-data-div">货号:</div>
                        <div class="list-data-div">{{ goods_number }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div">数量:</div>
                        <div class="list-data-div">{{ count }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div-a">货位:</div>
                        <div class="list-data-div-a">{{ goods }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div-a">款式:</div>
                        <div class="list-data-div-a">{{ ksType }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div-a">高度(m):</div>
                        <div class="list-data-div-a">{{ height_num }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div-a">宽度(m):</div>
                        <div class="list-data-div-a">{{ width_num }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div-a">备注:</div>
                        <div class="list-data-div-a">{{ reelInfo }}</div>
                    </div>
                    <div class="list-data">
                        <div class="list-data-div-a">时间:</div>
                        <div class="list-data-div-a">{{ nowtime }}</div>
                    </div>
                </div>
                <Barcode :JsBarcodeData="JsBarcodeConfigData" />
            </div>
            <van-button type="info" @click="dayin()" style="width: 100px; margin : 10px;">打印</van-button>
        </van-popup>
        <div class="filling-goods-bottom" style="display: flex">
            <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
            <van-button v-if="AllowPrint" type="info" class="bottom-button" @click="go_print()">打印标签</van-button>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
import Barcode from '@/components/Barcode';
import html2canvas from 'html2canvas';
import moment from 'moment';
export default {
    name: "Finished-out",  //瑞动
    name: "barcode",
    components: {
        Barcode
    },
    data() {
        return {
            hostcs: false,
            more_show: false,
            ray: "扫描中",
            id: "",
            supplier_xh: "",
            count: "",
            count_up: "",
            data: [],
            style: "",
            allcount: 0,
            reeldata: "",
            gckdata:'',
            goods_number: "",
            reelInfo: "",
            reelInfo_up: "",
            infoType: "1111",
            gck_number_data: "",
            outNumber: "未出库",
            username: "",
            type: "orderInfo",
            count: "",
            goods: '',
            ksType:'',
            success: false,
            show_print: false,
            AllowPrint: false,
            nowtime: '',
            jieliu: false,
            menfu: '',
            height_num: "",
            width_num: "",
            JsBarcodeConfigData: {
                text: '', // 条形码必须是字符串类型，否则会出现后面几位为数字的情况。
                lineColor: "#000000", //二维码颜色
                background: "#fff", //二维码背景色
                //width: this.widthStyleObj, 
                bottomtext: '',
            }
        };
    },
    mounted() {
        this.username = JSON.parse(window.localStorage.getItem("userinfo"));
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.style =
            "text-align: left;width: 100%;height: " + h * 0.66 + "px;overflow:scroll";
        setTimeout(() => {
            // this.countAll();
            if (this.outNumber === "未出库") {
                this.focus();
            }
        }, 500);
        if (window.location.host.indexOf("cspda") !== -1) {
            this.hostcs = true;
        }
    },
    methods: {
        goGck() {
            // 输入卷号 弹出现存量
            this.get(this.APIOBJ.ClothAdjustment, { reel: this.reeldata }).then(
                (res) => {
                    if (res.data.status == 1) {
                        // 如果是1  就说明成功
                        const regex = /(.*?)\/宽(\d+(\.\d+)?)\/高(\d+(\.\d+)?)/;
                        const matches = res.data.data.size.match(regex);
                        if (matches) {
                            this.ksType = matches[1]; // 韩折
                            this.width_num = matches[2]; // 2
                            this.height_num = matches[4]; // 3
                        }
                        this.count = res.data.data.store;
                        this.count_up = '';
                        this.goods = res.data.data.goods;
                        this.reelInfo = res.data.data.reel_detail;
                        this.reelInfo_up = res.data.data.reel_detail;
                        this.goods_number = res.data.data.number;
                        // this.success = true;
                        // this.AllowPrint = true;
                    } else if (res.data.status == 0) {
                        Toast(res.data.msg);
                        this.reeldata = '';
                        this.gckdata = '';
                    } else {
                        Toast('失败');
                    }
                }
            );
            this.gck_input();
        },
        goSX(){
            this.get(this.APIOBJ.gckGoodsorder, { gck_number: this.gckdata }).then(
                (res) => {
                    if (res.data.status == 1) {
                        // 如果是1  就说明成功
                        const resD = res.data.data;
                        if(this.width_num >= resD.cpcm && this.height_num >= resD.cpgd && this.goods_number == resD.goods_name){
                            this.success = true;
                            this.AllowPrint = true;
                        }else{
                            Toast('两个明细不匹配，不允许出库！');
                            this.gckdata = '';
                        }
                    } else if (res.data.status == 0) {
                        Toast(res.data.msg);
                        this.reeldata = '';
                    } else {
                        Toast('失败');
                    }
                }
            );
            this.gck_input();            
        },
        go_save() {
            if (this.count_up != "" && this.count_up >= 0) {
                this.post(this.APIOBJ.ClothAdjustment, { reel: this.reeldata, comment: this.reelInfo_up, reduce: this.count_up }).then(
                    (res) => {
                        if (res.data.status == 1) {
                            this.reelInfo = this.reelInfo_up;
                            this.count = this.count-this.count_up;
                            this.count_up = '';
                            Toast('更新保存成功');
                        } else {
                            Toast('更新失败');
                        }
                    }
                )
            }
            else {
                Toast('出库数量不能为空或负!');
            }
        },
        go_print() {
            // this.get("/IncreaseStore", {
            //   number: this.goods_number,
            //   reel_detail: this.reelInfo,
            //   cylinder_number: this.cylinder_number,
            //   store: this.count,
            //   supplier_name: this.supplier_name,
            //   supplier_xh: this.supplier_xh,
            //   menfu: this.menfu,
            // }).then((res) => {
            //   console.log(res.data);
            //   if (res.data.status == 1) {
            this.nowtime = moment().format('YYYY-MM-DD HH:mm:ss');
            this.JsBarcodeConfigData.text = this.reeldata;
            this.JsBarcodeConfigData.bottomtext = this.reeldata;
            this.show_print = true;
            this.jieliu = false;
            //   } else if (res.data.status == 0) {
            //     this.jieliu = false;
            //     Toast(res.data.msg)
            //   } else {
            //     this.jieliu = false;
            //     Toast("失败");
            //   }
            // })

        },
        dayin() {
            html2canvas(document.querySelector("#popupPrint")).then((canvas) => {
                //document.body.appendChild(canvas);
                var imageBase64 = canvas.toDataURL();// 将imageData作为参数传递给callAndroid()方法
                var imageBase64 = imageBase64.replace(/^data:image\/\w+;base64,/, '');
                this.count_up = '';
                this.callAndroid(imageBase64);
            });
        },
        callAndroid(imageBase64) {
            var BASE64_ENCODED_IMAGE_DATA = imageBase64;
            var imageData = BASE64_ENCODED_IMAGE_DATA;
            console.log(imageData);
            this.show_print = false;
            Android.receiveImage(imageData);
            alert("printPreview");
        },
        gck_input() {
            this.$refs.getGCKInpot.focus();
            this.$refs.getGCKInpot.setAttribute("readonly", "readonly");
            setTimeout(() => {
              this.$refs.getGCKInpot.removeAttribute("readonly");
            }, 200);
        },

        hideMessage(title) {
            if (title === "reeldata") {
                if (this.reeldata === "") {
                    this.ray = "已暂停，点击我继续扫码";
                }
            }
            if (title === "gckdata") {
                if (this.gckdata === "") {
                    this.ray = "已暂停，点击我继续扫码";
                }
            }
        },
        holdRay() {
            this.ray = "扫描中";
            if (this.reeldata === "") {
                this.focus();
            } else if (this.gckdata === "") {
                this.gck_input();
            }
        },
        focus() {
            this.$refs.getIDInpot.focus();
            this.$refs.getIDInpot.setAttribute("readonly", "readonly");
            setTimeout(() => {
                this.$refs.getIDInpot.removeAttribute("readonly");
            }, 200);
        },
        // gourl(url) {
        //   url = "http://www.lcyjfz.com/home/scan?url=" + url;
        //   window.location.href = url;
        // },
        go_index() {
            Dialog.confirm({
                message: "确定要回首页吗？",
            })
                .then(() => {
                    this.$router.push("/home");
                })
                .catch(() => {
                    // on cancel
                });
        },
        go_scan_url() {
            let url =
                "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
            window.location.href = url;
        },
    },
};
</script>

<style lang="less">
@import "../style/outOrderInfo.less";

.info-data {
    display: flex;
    padding: 0px 10px 10px 10px;
    align-items: center;
    justify-content: center;
}

.bottom-button-x {
    border-radius: 0.5em;
    width: 35%;
}

.list-data {
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
}

.out-input {
    width: 70%;
    height: 25px;
    line-height: 25px;
}

.list-data-div {
    padding-right: 3px;
    text-align: left;
    font-size: 18px;
}

.list-data-div-a {
    padding-right: 3px;
    text-align: left;
    font-size: 14px;
}
</style>